var _rect, _g, _defs;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgVk(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 30,
    height: 30,
    viewBox: "0 0 30 30",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 30,
    height: 30,
    rx: 5,
    fill: "#0077FF"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_216_317)"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M23.5875 10.461C23.712 10.0515 23.5875 9.75 22.9913 9.75H21.0225C20.5215 9.75 20.2905 10.0103 20.1652 10.2975C20.1652 10.2975 19.164 12.6945 17.7458 14.2515C17.2867 14.703 17.0782 14.8463 16.8278 14.8463C16.7025 14.8463 16.5142 14.703 16.5142 14.2928V10.461C16.5142 9.969 16.3763 9.75 15.9593 9.75H12.8632C12.5505 9.75 12.3622 9.978 12.3622 10.1947C12.3622 10.6605 13.0718 10.7685 13.1445 12.0795V14.928C13.1445 15.5528 13.0297 15.666 12.7792 15.666C12.1117 15.666 10.488 13.2577 9.52425 10.5022C9.3375 9.966 9.1485 9.75 8.64525 9.75H6.675C6.1125 9.75 6 10.0103 6 10.2975C6 10.809 6.6675 13.35 9.10875 16.7108C10.7362 19.0057 13.0275 20.25 15.1147 20.25C16.3665 20.25 16.521 19.974 16.521 19.4977V17.763C16.521 17.2102 16.6395 17.1 17.0363 17.1C17.3287 17.1 17.829 17.244 18.9975 18.3502C20.3325 19.662 20.5523 20.25 21.3038 20.25H23.2725C23.835 20.25 24.117 19.974 23.955 19.428C23.7765 18.885 23.139 18.0968 22.2938 17.1615C21.8348 16.629 21.1463 16.0553 20.937 15.768C20.6453 15.3998 20.7285 15.2355 20.937 14.9078C20.937 14.9078 23.337 11.5882 23.5868 10.461H23.5875Z",
    fill: "white"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_216_317"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 18,
    height: 18,
    fill: "white",
    transform: "translate(6 6)"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgVk);
export default __webpack_public_path__ + "static/media/Vk.c89805d26196e004568d16cf1c186cce.svg";
export { ForwardRef as ReactComponent };